"use client";
import { jsx, jsxs } from "react/jsx-runtime";
import { InputHelperText } from "../../../building-blocks/inputs/InputHelperText.js";
import { Column } from "../../../utilities/layout/Column.js";
import "../../../utilities/layout/Row.js";
import { atoms } from "@gnist/themes/atoms.css.js";
const HelperTextWrapper = ({ children, id, validity, reserveSpaceForMessage, helperText }) => {
  return jsxs(Column, { className: atoms({ position: "relative" }), children: [children, jsx(InputHelperText, { className: atoms({ marginLeft: "base" }), id, helperText, validity, reserveSpaceForMessage })] });
};
const SelectionDescription = ({ disabled, children }) => {
  return jsx("div", { className: disabled ? atoms({ color: "on-disabled" }) : void 0, children });
};
export {
  HelperTextWrapper,
  SelectionDescription
};
